import { useDispatch, useSelector } from 'react-redux';
import { selectors, effects } from 'lib/entities/livestream';
import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import SEO from 'global/SEO';
import { format, parseISO } from 'date-fns';
import { EVENT_STATUS } from 'global/LiveStreamWidget/constants';
import StreamBoxLeft from './StreamBoxLeft';
import StreamBoxRight from './StreamBoxRight';
import { Container, Wrapper } from './styled';
import Shimmer from './Shimmer';
import ModalLiveError from './Modal/ModalLiveError';
import { sourceMapperLiveStream } from '../constants';
import LivestreamAnalytics from './analytics/Livestream';

interface LiveStreamProps {
  eventId: string;
  isError?: boolean;
}

function LiveStream({ eventId, isError }: LiveStreamProps) {
  const dispatch = useDispatch();
  const router = useRouter();
  const { event: { data: eventData, isLoading } } = useSelector(selectors);
  const [showErrorModal, setShowErrorModal] = useState(false);

  const sendAnalytic = () => {
    const { schedule } = eventData;
    const { source } = router.query;
    const clevertapParams = {
      event_date: format(parseISO(schedule?.start), 'dd MMMM yyyy'),
      event_status: eventData?.status === EVENT_STATUS.LIVE ? 'Live' : 'Upcoming',
      reminder_status: eventData?.reminder_enabled ? 'on' : 'off',
      live_stream_name: eventData?.title,
      // @ts-ignore
      source: source ? sourceMapperLiveStream[source] : sourceMapperLiveStream.stream,
    };
    LivestreamAnalytics.Navigate.ViewPage(clevertapParams);
  };

  const getEventDetail = async () => {
    const getEvent = await dispatch(effects.getEvent(eventId));

    // @ts-ignore
    const { data } = getEvent.payload;

    if (!data) {
      setShowErrorModal(true);
    }
  };

  useEffect(() => {
    document.getElementById('main-container')
      .setAttribute('style', `
        height: calc(100vh - 100px);
        max-width: unset;
        overflow-y: hidden;
      `);
    document.getElementsByTagName('body')[0]
      .setAttribute('style', `
        height: unset;
      `);
    document
      .getElementById('main-container')
      .getElementsByTagName('div')[0]
      .setAttribute('style', 'display: none');

    getEventDetail();
  }, []);

  useEffect(() => {
    if (eventData) {
      sendAnalytic();
    }
  }, [eventData]);

  if (isLoading || !eventData || isError) {
    const closeModalEnded = () => {
      setShowErrorModal(false);
      router.push('/stream');
    };

    const handleReload = () => {
      router.reload();
    };

    return (
      <>
        <Shimmer />
        <ModalLiveError
          visible={showErrorModal}
          onCancel={closeModalEnded}
          onReload={handleReload}
        />
      </>
    );
  }

  return (
    <Wrapper>
      <SEO />
      <Container>
        <StreamBoxLeft event={eventData} />
        <StreamBoxRight event={eventData} />
      </Container>
    </Wrapper>
  );
}

export default LiveStream;
